import general from '../general.js'
import formCreator from './formCreator.js'
import editableReferencesDeleter from './editableReferencesDeleter'
import formResourcesManager from './formResourcesManager.js'

import store from '../../store.js'

let editableReferenceItem = function (options) {
	return {
		init: function () {
			this.instances = options.instances
			this.allInstances = options.allInstances
			this.addClass = options.addClass
			this.permissions = options.permissions
			this.editableReferencesContainer = options.editableReferencesContainer
			this.languages = options.languages
			this.entity = options.entity
			this.routeChangeSuccess = options.routeChangeSuccess
			this.editableRefInt = options.editableRefInt
			this.startUniform = options.startUniform
			this.referencedForm = options.referencedForm
			this.referencedFormClone = options.referencedFormClone
			this.defaultLang = options.defaultLang
			this.counter = options.counter
			this.editableRefIntCounter = options.editableRefIntCounter

			// create container for fields
			var editableItemContainer = document.createElement('div')
			editableItemContainer.className = 'item editable-reference-item draggable-item ' + this.addClass

			// create grip to sort
			var handle = document.createElement('div')
			handle.className = 'handle'
			var grip = document.createElement('div')
			grip.className = 'grip'

			var uuid = ''
			if (this.instances) {
				uuid = this.instances[Object.keys(this.instances)[0]].uuid
			}

			if (this.permissions.delete) {
				// create delete button
				var deleteBtn = document.createElement('a')
				deleteBtn.setAttribute('href', '#')
				deleteBtn.className = 'btn-remove fa fa-trash-alt transition-fadeinup transition-delay-01 btn-remove-reference-block'
				deleteBtn.setAttribute('data-uuid', uuid)
			}

			// create collapse toggle for this specific reference
			var collapseBtn = document.createElement('a')
			collapseBtn.setAttribute('href', '#')
			collapseBtn.className = 'btn-collapse-individual transition-fadeinup fa fa-pen'

			editableItemContainer.setAttribute('data-uuid', uuid)

			handle.appendChild(grip)
			editableItemContainer.appendChild(handle)
			if (deleteBtn) editableItemContainer.appendChild(deleteBtn)
			editableItemContainer.appendChild(collapseBtn)

			if (deleteBtn) deleteBtn.addEventListener('click', this.deleteEditableReferenceForm.bind(this))

			this.editableReferencesContainer.appendChild(editableItemContainer)

			var form = this.referencedForm
			if (this.addClass) {
				form = this.referencedFormClone
			}

			// create form
			formCreator({
				layout: 'multiple',
				data: form,
				languages: this.languages,
				instances: this.instances,
				container: editableItemContainer,
				entityProperties: this.entity.properties,
				callback: this.referenceCreated.bind(this),
				editableReference: true,
				currentLanguage: this.currentLang,
				editableRefInt: this.editableRefInt,
				entity: this.entity,
				startUniform: this.startUniform
			}).init()

			// add content to show when our editable reference is collapsed
			var collapsedView = document.createElement('div')
			collapsedView.classList.add('collapsed-view')
			var span = document.createElement('span')
			var dataToShow = 'New item'
			let renderInstant = true
			if (this.instances) {
				// find the default lang instance
				var dataFirstInstance = null
				for (var inst in this.instances) {
					if (this.instances[inst].market.id === this.defaultLang.id) {
						dataFirstInstance = this.instances[inst].data
						break
					}
				}

				let propertyToShow = null
				var fieldType = null
				this.referenceFieldId = null
				for (var key in this.entity.properties) {
					if (!this.entity.properties[key].settings) continue
					if (!key) continue
					if (this.entity.properties[key].settings.orderinoverview) {
						if (this.entity.properties[key].settings.orderinoverview.value === '1') {
							propertyToShow = key
							fieldType = this.entity.properties[key].settings.type.value

							if (fieldType === 'Reference') {
								this.referenceFieldId = this.entity.properties[key].settings.referenceFieldId.value
							}
							break
						}
					}
				}

				if (dataFirstInstance !== null && dataFirstInstance.hasOwnProperty(propertyToShow)) {
					if (fieldType === 'Link') {
						if (general.isJson(dataFirstInstance[propertyToShow].value)) {
							dataToShow = JSON.parse(dataFirstInstance[propertyToShow].value)[1] + ' (' + JSON.parse(dataFirstInstance[propertyToShow].value)[0] + ')'
						} else {
							dataToShow = dataFirstInstance[propertyToShow].value
						}
					} else if (fieldType === 'Dropzone') {
						var domain = Object.keys(store.getters.project.domains)[0].replace(/\/$/, '')
						var arr = dataFirstInstance[propertyToShow].value
						if (general.isJson(arr)) {
							arr = JSON.parse(dataFirstInstance[propertyToShow].value)
						}

						dataToShow = ''
						for (var im = 0; im < arr.length; im++) {
							dataToShow = dataToShow + '<div class="image" style="background-image: url(' + domain + '/uploads/original/' + this.entity.name + '/' + arr[im] + ')"></div>'
						}
					} else if (fieldType === 'Reference') {
						renderInstant = false
						const url = `/cms/api/instances?uuid2=${dataFirstInstance[propertyToShow].value}`
						formResourcesManager.fetchOtherEndpoints(this.fetchReferenceDataCompleted.bind(this), url)

						this.referenceContainers = {
							span: span,
							collapsedView: collapsedView,
							editableItemContainer: editableItemContainer
						}
					} else {
						dataToShow = dataFirstInstance[propertyToShow].value
					}
				}
			}

			if (renderInstant === true) {
				span.innerHTML = dataToShow
				collapsedView.appendChild(span)
				editableItemContainer.appendChild(collapsedView)
			}
		},

		fetchReferenceDataCompleted: function (data) {
			// find referenceField in entity properties
			const referenceFieldName = data.linked.entity[Object.keys(data.linked.entity)[0]].properties[this.referenceFieldId].name
			const dataToShow = data.data[Object.keys(data.data)[0]].data[referenceFieldName].value

			this.referenceContainers.span.innerHTML = dataToShow
			this.referenceContainers.collapsedView.appendChild(this.referenceContainers.span)
			this.referenceContainers.editableItemContainer.appendChild(this.referenceContainers.collapsedView)
		},

		deleteEditableReferenceForm: function (e) {
			e.preventDefault()
			var confirm = window.confirm('Are you sure you want to remove this item?')
			if (!confirm) return
			var uuid = e.currentTarget.getAttribute('data-uuid')

			// set all instances with this UUID to state 5 and post them
			// also remove this whole editable reference from the page
			if (uuid) {
				var obj = {
					'entity': null,
					'uuid': null,
					'instance': []
				}

				for (var i = this.allInstances.data.length - 1; i >= 0; i--) {
					if (this.allInstances.data[i].uuid === uuid) {
						if (!obj.entity) {
							obj.entity = this.allInstances.data[i].entity.id
							obj.uuid = this.allInstances.data[i].uuid
						}

						obj.instance.push({
							'id': this.allInstances.data[i].id,
							'market': this.allInstances.data[i].market.id,
							'state': 5
						})
					}

					if (i === 0) {
						editableReferencesDeleter.addToQueue(obj)
					}
				}

				this.removeElementFromPage(e.currentTarget)
			} else {
				this.removeElementFromPage(e.currentTarget)

				// this.editableRefInt--
				this.editableRefIntCounter('-')
				// this.count--
				this.counter('-')
				this.evalutateMaxItems()
			}
		},

		removeElementFromPage: function (target) {
			var element = target.parentNode
			var wrapper = element.parentNode

			wrapper.removeChild(element)
		},

		referenceCreated: function () {
			this.routeChangeSuccess()
		}
	}
}

export default editableReferenceItem
